import { Injectable } from "@angular/core";
import { CanActivate, ActivatedRouteSnapshot, Router, RouterStateSnapshot } from "@angular/router";
import { AuthenticationService } from "@biletix/core/services/authentication.service"; 
import { RouteParameter } from "../common/constants/route-parameter.const";
import { EventService } from "../services/event.service";
import { of } from 'rxjs';
import { catchError, map, take } from 'rxjs/operators';
import { ApiResponseStatus } from "../models/api-response-status";
import { RegionService } from "../services/region.service";
import { I18nService } from "../services/i18n.service";

@Injectable({
    providedIn: 'root'
})
export class EventAnonimUserProtectGuard implements CanActivate {

    constructor(
        private authenticationService: AuthenticationService,
        private router: Router,
        private eventService: EventService,
        private region: RegionService,
        private i18n: I18nService,
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const eventCode: string = route.params[RouteParameter.PARAMS.EVENT_CODE].toUpperCase();

        const region: string = route.params[RouteParameter.PARAMS.REGION];
        const language: string = route.params[RouteParameter.PARAMS.LANGUAGE];

        const returnUrl = `/etkinlik/${eventCode}/${region}/${language}`;
        console.log(`Return URL: ${returnUrl}`);

        return this.eventService.findByEventCode(eventCode).pipe(
            take(1),
            map(response => {
                if (response && response.status === ApiResponseStatus.SUCCESS) {
                    const eventDetail = response.data;
                    if (eventDetail.restrictedToAnonimUser) {
                        // Anonim kullanıcı ise login sayfasına yönlendir
                        if (!this.authenticationService.isAuthenticated()) {
                            const stateObj: any | { returnUrl: string } = {
                                returnUrl: returnUrl
                            };
                            this.router.navigate([
                                '/auth',
                                this.region.regionName,
                                this.i18n.currentLang,
                                'login'
                            ],
                                {
                                    state: stateObj,
                                    queryParams: stateObj
                                }
                            );
                            return false;
                        }
                        return true;
                    } else {
                        return true;
                    }
                } else {
                    this.router.navigate(['/error']);
                    return false;
                }
            }),
            catchError(err => {
                console.error("Error occurred while fetching event:", err);
                this.router.navigate(['/error']);
                return of(false);
            })
        );
    }
}
